export default __webpack_public_path__ + "static/media/semgrep.51c4b20b.svg";